import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSkiNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M12 17.83l3.11 5.84h4.28l-4.23-7.96-1.02-1.9 4.27-8.02a4.75 4.75 0 00-.17-4.74h-1.59L12 9.78 7.35 1.05H5.76a4.749 4.749 0 00-.17 4.74l4.27 8.02-5.25 9.86h4.28zm3.72 1.84l1.42 2.66h-1.22l-1.42-2.66zm1.71-17.21a3.401 3.401 0 01-.21 2.7l-1.16 2.17h-1.22zm-3.3 6.21h1.22l-1.97 3.7-.61-1.15zM6.78 5.16a3.4 3.4 0 01-.21-2.7l2.59 4.87H7.94zm1.87 3.51h1.22l5.14 9.66h-1.22l-.01-.03-2.39-4.48zm1.98 6.58l.61 1.15-1.03 1.93H8.99zm-3.77 7.08l1.42-2.66H9.5l-1.42 2.66z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSkiNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsSkiNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSkiNormalSmall;
